export const GET_TOKENS_REQUEST = 'GET_TOKENS_REQUEST';
export const GET_TOKENS_DATA = 'GET_TOKENS_DATA';
export const GET_TOKENS_ERROR = 'GET_TOKENS_ERROR';

export const GET_TOKEN_REQUEST = 'GET_TOKEN_REQUEST';
export const GET_TOKEN_DATA = 'GET_TOKEN_DATA';
export const GET_TOKEN_ERROR = 'GET_TOKEN_ERROR';

export const ADD_TOKEN = 'ADD_TOKEN';
export const TOKEN_ADDED = 'TOKEN_ADDED';

export const FILTER_TOKENS = 'FILTER_TOKENS';
export const SET_FILTER_INPUT = 'SET_FILTER_INPUT';
export const SET_TOKEN_SORT_DATA = 'SET_TOKEN_SORT_DATA';
export const SORTING_TOKENS = 'SORTING_TOKENS';

export const BUY_TOKEN_DATA = 'BUY_TOKEN_DATA';
export const BUY_TOKEN_ERROR = 'BUY_TOKEN_ERROR';
export const BUY_TOKEN_MODAL = 'BUY_TOKEN_MODAL';

export const SWAP_TOKEN_DATA = 'SWAP_TOKEN_DATA';
export const SWAP_TOKEN_ERROR = 'SWAP_TOKEN_ERROR';
export const SWAP_TOKEN_MODAL = 'SWAP_TOKEN_MODAL';

export const UPDATE_QUICK_FILTER = 'UPDATE_QUICK_FILTER';

export const GET_BNB_REQUEST = 'GET_BNB_REQUEST';
export const GET_BNB_DATA = 'GET_BNB_DATA';
export const GET_BNB_ERROR = 'GET_BNB_ERROR';